import { useEffect, useState } from "react";
import { SuccessFetch } from "types";
import { useApi } from "utils";
import { CurrentStockPerformenceResponse } from "../../types/CurrentStockPerformence";

type UseCurrentStockPerformence = {
  date: string;
  location_id?: string;
  category_id?: string;
  page?: number;
  limit?: number;
};

type PaginationType = {
  total: number
  page: number
  size: number
  pages: number
}

export const useCurrentStockPerformence = ({ date, location_id, category_id, limit, page }: UseCurrentStockPerformence) => {
  const api = useApi();
  const [data, setData] = useState<CurrentStockPerformenceResponse | null>(null);
  const [pagination, setPaginationData] = useState<PaginationType | null>(null);

  const params: Record<string, string | number> = {
    year_month: date,
    ...(location_id && { location_id }),
    ...(category_id && { category_id }),
    ...(limit && { limit }),
    ...(page && { page }),
  };

  const fetchData = () => {
    api.get("/dasboard_inventory/current-stock-performance", { params })
    .then((res: SuccessFetch<{ payload: CurrentStockPerformenceResponse, pagination_data: PaginationType }>) => {
      setData(res.data.payload)
      setPaginationData(res.data.pagination_data)
    })
    .catch(() => {
      setData(null)
      setPaginationData(null)
    });
  };

  useEffect(() => {
    fetchData();
    return () => {
      setData(null)
      setPaginationData(null)
    };

    // eslint-disable-next-line
  }, [date, location_id, category_id, limit, page]);

  const fetchAll = async () => {
    const res = await api.get(
      "/dasboard_inventory/current-stock-performance",
      {
        params: {
          year_month: date,
          ...(location_id && { location_id }),
          ...(category_id && { category_id }),
          page: 1,
          limit: -1
        }
      }
    );

    return res.data.payload as CurrentStockPerformenceResponse;
  };

    return { fetchData, data, pagination,fetchAll };
}
